//import { helpers } from '../helpers.js';

var counterBox = {
  options: {
    input_artificially_triggered: false,
  },

  selectors: {
    // global selectors
  },

  init: function () {
    const self = this;

    const counter_boxes = jQuery(".js-counter-box");

    if (counter_boxes.length === 0) {
      return;
    }

    //Initital run
    counter_boxes.each(function () {
      const counter_box_element = jQuery(this);
      self.setCount(parseInt(counter_box_element.find("input").val()), counter_box_element.find("input"), counter_box_element);

      //is disabled?
      if (counter_box_element.data("disabled") == true) {
        counter_box_element.find("button").attr("disabled", true);
        counter_box_element.find("input").attr("disabled", true);
      }
    });

    jQuery(".js-counter-box input").on("input", function () {
      if (self.options.input_artificially_triggered) {
        self.options.input_artificially_triggered = false;
        return;
      }

      const input_element = jQuery(this);
      self.setCount(parseInt(input_element.val()), input_element, input_element.parent());
    });

    jQuery(".js-counter-box button").on("click", function (event) {
      event.preventDefault();
      const counter_box_element = jQuery(this).parent();

      const step = (typeof counter_box_element.data("step") !== "undefined") ? parseInt(counter_box_element.data("step")) : 1;

      let new_value = 0;
      if (jQuery(this).data("type") == "plus") {
        new_value = parseInt(counter_box_element.find("input").val()) + step;
      } else {
        new_value = parseInt(counter_box_element.find("input").val()) - step;
      }

      self.setCount(new_value, counter_box_element.find("input"), counter_box_element);
    });
  },

  setCount: function (new_quantity, jquery_input, jquery_counter_box) {
    const self = this;

    if (isNaN(new_quantity)) new_quantity = 0;

    let min = 0;
    if (typeof jquery_counter_box.data("min") !== "undefined") min = parseInt(jquery_counter_box.data("min"));

    let max = 99;
    if (typeof jquery_counter_box.data("max") !== "undefined") max = parseInt(jquery_counter_box.data("max"));

    if (new_quantity < min) new_quantity = min;
    if (new_quantity > max) new_quantity = max;

    if (new_quantity === min) {
      jquery_counter_box.children("button[data-type='minus']").attr("disabled", true);
    } else {
      jquery_counter_box.children("button[data-type='minus']").attr("disabled", false);
    }

    if (new_quantity === max) {
      jquery_counter_box.children("button[data-type='plus']").attr("disabled", true);
      jquery_counter_box.children("span.limit-reached").addClass("show");
    } else {
      jquery_counter_box.children("button[data-type='plus']").attr("disabled", false);
      jquery_counter_box.children("span.limit-reached").removeClass("show");
    }

    self.options.input_artificially_triggered = true;

    if (new_quantity != jquery_input.val() || jquery_input.val() === "") {
      jquery_input.val(new_quantity).trigger("input");
    }
  }
}

// Export
export { counterBox };